import { useState, useEffect } from 'react';
import { fetchWorkflows } from '../services/homeService';

export const useWorkflows = (token, handleLogout) => {
  const [workflows, setWorkflows] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState(null);

  useEffect(() => {
    (async () => {
      const data = await fetchWorkflows(token, deleteStatus, handleLogout);
      setWorkflows(data);
    })();
  }, [token, deleteStatus, handleLogout]);

  return { workflows, setDeleteStatus, setWorkflows };
};
